import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';

export default function PublishConfirmDialog({
  open,
  onClose,
  onConfirm,
  workspaceName,
  isPublishing,
  publishError,
}) {
  return (
    <Dialog open={open} onClose={isPublishing ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Publish Workspace</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Publish <strong>{workspaceName || 'this workspace'}</strong>?
        </DialogContentText>
        <DialogContentText sx={{ mt: 1 }}>
          The current draft will become the live published version. All assigned users will see the
          updated layout on their next page load.
        </DialogContentText>
        {publishError && (
          <Typography color="error" variant="body2" sx={{ mt: 1 }}>
            {publishError}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isPublishing}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          disabled={isPublishing}
          startIcon={isPublishing ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {isPublishing ? 'Publishing…' : 'Publish'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
